import { GetFormalOffersResponse } from '@iwoca/lapi-client/edge';

import { mapOfferDurationToMonths } from '../../../utils/mapOfferDurationToMonths';

export const mapOfferDurationToProduct = (
  offer: NonNullable<
    NonNullable<GetFormalOffersResponse['data']>['formal_offers']
  >[number],
) => {
  const duration = mapOfferDurationToMonths(offer);

  switch (duration) {
    case 1:
      return 'THIRTY_DAYS';
    case 3:
      return 'THREE_MONTHS';
    case 12:
      return 'TWELVE_MONTHS';
    default:
      console.error('Unable to map duration to product:', duration);
      return null;
  }
};
